import { AutoRow } from 'components/Layout/Row'
import { useTranslation } from 'contexts/Localization'
import { questTypeToName, questSymbolToTypePostfix } from 'views/VvsGotchi/config'
import QuestButton from 'views/VvsGotchi/components/QuestButton'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { getExpBrief } from 'views/VvsGotchi/utils/quest'
import { Text, Box, Grid, Flex, Img } from 'vvs-uikit'

import { QuestsListProps } from './types'

const DefaultQuestsList: React.FC<QuestsListProps> = ({ quests, owner }) => {
  const { t } = useTranslation()

  return (
    <Grid px={3} py={4} gridTemplateColumns="repeat(2, 1fr)" gridGap="2em 1.25em" justifyItems="center">
      {quests
        .map((q) => ({ q, expBrief: getExpBrief(q, owner, t) }))
        .map(({ q, expBrief }) => (
          <Flex key={q.symbol} width="100%" flexDirection="column">
            <QuestButton quest={q} />
            <Box mt={2}>
              {expBrief && (
                <AutoRow>
                  <Img src="/images/vvsGotchi/star.png" height="16px" />
                  <Text ml={1} color="black">
                    {expBrief}
                  </Text>
                </AutoRow>
              )}
              {q.type !== undefined && (
                <AutoRow>
                  <PixelatedImage src="/images/vvsGotchi/location.png" width="12px" mx="1.5px" />
                  <Text ml={1} color="black">
                    {questTypeToName[q.type]?.(t)}
                    {questSymbolToTypePostfix[q.symbol]?.(t)}
                  </Text>
                </AutoRow>
              )}
            </Box>
          </Flex>
        ))}
    </Grid>
  )
}

export default DefaultQuestsList
